var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.742 13.378-2.036-1.976s-.36-.42-.958-.24l-1.557.54s-1.198-1.378-1.857-2.396C5.615 8.347 4.777 6.73 4.777 6.73l1.018-1.257c.42-.54.12-1.018.12-1.018L4.777 1.819c-.18-.419-.54-.419-.54-.419-.418-.06-2.515 1.438-2.515 1.438-.778.479-.718 1.018-.718 1.018-.12 3.294 2.635 6.947 2.815 7.306.3.36 2.635 4.252 5.75 5.27-.001 0 .478.24 1.197-.299 0 0 2.036-1.557 2.156-2.036 0-.06.12-.42-.18-.719z",
    stroke: "#1E1F23",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
};

export default SvgPhone;